var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" ✨ 并行网关无设置项 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }